import styled, { css } from 'styled-components';
import { gridGap, layout, GridProps, LayoutProps } from 'styled-system';

export const Container = styled.div<GridProps>`
  display: flex;
  ${gridGap};
`;

export const Navigation = styled.div<{ isDisabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ theme }) => css`
    color: ${theme.colors.gray.light};

    &:hover {
      color: ${theme.colors.primary.dark};
    }

    &:focus-visible {
      outline: 1px solid ${theme.colors.primary.main};
    }
  `};

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
    `};

  transition: color 0.2s linear;
`;

export const Page = styled.div<LayoutProps & { isActive: boolean }>`
  ${layout};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  ${({ theme, isActive }) => css`
    color: ${theme.colors.primary.dark};

    &:hover {
      background: ${theme.colors.primary.extraLight};
    }

    &:focus-visible {
      outline: 1px solid ${theme.colors.primary.main};
    }

    ${
      isActive &&
      css`
        color: ${theme.colors.white.main};
        background: ${theme.colors.primary.dark};

        &:hover {
          background: ${theme.colors.primary.dark};
        }
      `
    }};
  `};

  transition: color 0.2s, background 0.2s linear;
`;
